import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setUpcomingCheckoutSplitsOrder = {
  name: "setUpcomingCheckoutSplitsOrder" as const,
  input: z.array(zExt.objectId()),
  output: z.null(),
};
